export class SubRemover {
	private _entries:SubRemoverEntry[];
	
	constructor(){
		this._entries = [];
	}
	
	/**saves the entry for removal and also calls addEventListener to create
	 * the sub*/
	public add(context:EventTarget, eventType:string,
			callback:EventListenerOrEventListenerObject){
		context.addEventListener(eventType, callback);
		this._entries.push({ context, eventType, callback} );
	}
	
	/**saves the entry for removal without calling addEventListener */
	public store(context:EventTarget, eventType:string,
			callback:EventListenerOrEventListenerObject):void {
		this._entries.push({ context, eventType, callback} );
	}
	
	/**removes any entries with matching parameters and also calls
	 * removeEventListener */
	public remove(context:EventTarget, eventType:string,
			callback:EventListenerOrEventListenerObject):void {
		context.removeEventListener(eventType, callback);
		for (let i = this._entries.length - 1; i >= 0; i--){
			let e = this._entries[i];
			if (e.context === context && e.eventType === eventType &&
					e.callback === callback){
				this._entries.splice(i, 1);
			}
		}
	}
	
	/**calls removeEventListener for all stored entries */
	public removeAllSubs():void {
		for (let e of this._entries){
			e.context.removeEventListener(e.eventType, e.callback);
		}
		this._entries = [];
	}
}

type SubRemoverEntry = {
	context:EventTarget,
	eventType:string,
	callback:EventListenerOrEventListenerObject
}